<template>
  <b-modal
    v-model="isOpen"
    has-modal-card
    trap-focus
    scroll="keep"
    aria-role="dialog"
    aria-label="CommentairesModale"
    aria-modal
    class="CommentairesModale"
    @cancel="emitCloseModale"
  >
    <div class="modal-card">
      <header class="modal-card-head modal-card-head-notes">
        {{ $t("commentairesModale.title") }}
      </header>

      <section class="modal-card-body">
        <div v-for="commentaire in commentaires" :key="commentaire.id" class="columns mt-1 mb-0">
          <div class="column is-one-third">
            <div class="columns">
              <div class="column pb-0">
                {{ commentaire.auteur.prenom + " " + commentaire.auteur.nom }}
              </div>
            </div>
            <div class="columns">
              <div class="column pb-0 today date-style">
                {{ formatDate(commentaire.dateCreation) }}
              </div>
              <div class="column pt-4 pb-0">
                <b-icon icon="comment-alt" size="is-small" type="is-info"></b-icon>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="columns">
              <div class="column pb-0">
                <div class="textarea-container">
                  <div class="box message">
                    {{ commentaire.contenu }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot">
        <div class="buttons">
          <div class="hoverable-discrete-link mr-3" @click="emitCloseModale">
            {{ $t("annuler") }}
          </div>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { CommentaireDTO } from "@/model/bean/GeneratedDTOs"
import { BIcon, BModal } from "buefy"

import DateUtils from "@/services/DateUtils"

export default defineComponent({
  name: "CommentairesModale",
  components: { BModal, BIcon },
  props: {
    commentaires: {
      type: Array as PropType<CommentaireDTO[]>,
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
  },

  emits: ["close-modale"],
  computed: {
    isOpen: {
      get(): boolean {
        return this.open
      },
      set(value: boolean): void {
        if (!value) {
          this.emitCloseModale()
        }
      },
    },
  },
  methods: {
    emitCloseModale(): void {
      this.$emit("close-modale")
    },

    formatDate(date: Date): string {
      return DateUtils.formatDate(date)
    },
  },
})
</script>

<style lang="scss"></style>
